import { render, staticRenderFns } from "./IntentionProceedStep.vue?vue&type=template&id=23e5eff6"
import script from "./IntentionProceedStep.vue?vue&type=script&lang=ts"
export * from "./IntentionProceedStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports